import { defineMessages } from 'react-intl'

const messages = {
  title: {
    id: 'app.components.product-decline-form.title',
    defaultMessage: 'Tell us the reason',
  },
  formButton: {
    id: 'app.components.product-decline-form.form-button',
    defaultMessage: 'Ok',
  },
}

export default defineMessages(messages)
